import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=22316afd&scoped=true&"
import script from "./Square.vue?vue&type=script&lang=ts&"
export * from "./Square.vue?vue&type=script&lang=ts&"
import style0 from "./Square.vue?vue&type=style&index=0&id=22316afd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22316afd",
  null
  
)

export default component.exports